import { connect } from 'react-redux';
import { RootState } from '../../../../../store/root-reducer';
import {
  deleteAttachmentRequest,
  uploadAttachmentRequest,
} from '../../../../../components/sequence/extra-actions';
import {
  AttachmentDeletePayload,
  AttachmentUploadPayload,
} from '../../../../../components/sequence/types';
import {
  resetDeleteAttachmentRequest,
  resetUploadAttachmentRequest,
} from '../../../../../components/sequence/sequence-slice';
import { createTaskRequest } from '../../../../../components/tasks/extra-actions';
import { resetCreateTaskRequest } from '../../../../../components/tasks/tasks-slice';
import { addPhoneNumberRequest } from '../../../../../components/settings/components/do-not-call/extra-actions';
import { resetAddPhoneNumberRequest } from '../../../../../components/settings/components/do-not-call/do-not-call-slice';
import { AddPhoneNumberPayload } from '../../../../../components/settings/types/do-not-call-list';
import PostCallOutcomeModal from './post-call-outcome-modal';
import { getCallOutcomeListRequest } from '../../../../../components/dialer/extra-actions';

const mapStateToProps = (state: RootState) => ({
  uploadAttachmentRequestStatus: state.sequence.uploadAttachmentRequest.status,
  uploadAttachmentRequestError: state.sequence.uploadAttachmentRequest.error,
  uploadedAttachment: state.sequence.uploadedAttachment,
  deleteAttachmentRequestStatus: state.sequence.deleteAttachmentRequest.status,
  deleteAttachmentRequestError: state.sequence.deleteAttachmentRequest.error,
  deletedAttachmentId: state.sequence.deletedAttachmentId,
  createTaskRequestStatus: state.tasks.createTaskRequest.status,
  remainingProspectLimit:
    state.home.getPostLoadMetaResponse?.accountUsageQuotaRemaining?.[
      'PROSPECT.ADD'
    ],
  addPhoneNumberRequestStatus:
    state.callDoNotContact.addPhoneNumberRequest.status,
  getCallLogsProspectProfileSectionResponse:
    state.dialer.getCallLogsProspectProfileSectionResponse,
  isDemoAccount: state.home.isDemoAccount,
});

const mapDispatchToProps = {
  handleSendAttachmentUploadRequest: (payload: AttachmentUploadPayload) =>
    uploadAttachmentRequest(payload),
  handleResetUploadAttachmentRequest: () => resetUploadAttachmentRequest(),
  handleSendDeleteAttachmentRequest: (payload: AttachmentDeletePayload) =>
    deleteAttachmentRequest(payload),
  handleResetDeleteAttachmentRequest: () => resetDeleteAttachmentRequest(),
  sendCreateTaskRequest: (payload: unknown) => createTaskRequest(payload),
  resetCreateTaskRequest: () => resetCreateTaskRequest(),
  sendAddPhoneNumberRequest: (payload: AddPhoneNumberPayload) =>
    addPhoneNumberRequest(payload),
  resetAddPhoneNumberRequest: () => resetAddPhoneNumberRequest(),
  sendGetCallOutcomeListRequest: () => getCallOutcomeListRequest({}),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PostCallOutcomeModal);
